import {createSystem, defaultConfig, defineConfig} from '@chakra-ui/react';

export const config = defineConfig({
  strictTokens: true,
  cssVarsRoot: ':where(:root, :host)',
  theme: {
    semanticTokens: {
      colors: {
        bg: {
          DEFAULT: {
            value: {_light: 'white', _dark: '#141523'} // Direct values ensure correct application
          }
        },
        green: {
          contrast: {
            value: {_light: 'white', _dark: 'white'}
          },
          fg: {
            value: {_light: 'green.700', _dark: 'green.300'}
          },
          subtle: {
            value: {_light: 'green.100', _dark: 'green.900'}
          },
          muted: {
            value: {_light: 'green.200', _dark: 'green.800'}
          },
          emphasized: {
            value: {_light: 'green.300', _dark: 'green.700'}
          },
          solid: {
            value: {_light: 'green.600', _dark: '#01D676'}
          },
          focusRing: {
            value: {_light: 'green.600', _dark: 'green.600'}
          }
        }
      }
    },
    tokens: {
      fonts: {
        heading: {value: "'Rubik', sans-serif"},
        body: {value: "'Rubik', sans-serif"}
      }
    },
    recipes: {
      button: {
        variants: {
          variant: {
            ghost: {
              borderWidth: '1px',
              borderColor: 'transparent',
              color: 'transparent',
              minHeight: '48px',
              padding: 0,
              _hover: {
                bg: 'transparent',
                _expanded: {
                  bg: 'transparent'
                }
              }
            }
          }
        }
      }
    }
  }
});

export const system = createSystem(defaultConfig, config);
